// extracted by mini-css-extract-plugin
export default {"departments":"MF-z","departmentHeading":"NF-z","departmentSection":"OF-z","departmentName":"PF-z","departmentLink":"QF-z","expandIcon":"RF-z"};